import {ThemeIconKey} from 'platform/foundation';

import {ReactNode} from 'react';

import {AllOrNone, Nullish} from 'shared/web';

import {ButtonProps} from '../Button/Button';
import {FlagProps} from '../Flag/Flag';

export interface NotificationItemDataBase {
  id: string;
  isRead?: boolean;
  userName?: string;
  getAvatarUrl?: () => Promise<string | undefined>;
  icon?: ThemeIconKey;
  created?: Date;
  title: string | ReactNode;
  message?: string;
  flags?: Omit<FlagProps, 'size'>[];
  actions?: Omit<ButtonProps, 'size'>[];
}

export type NotificationItemData = NotificationItemDataBase &
  (
    | AllOrNone<{
        onClick: () => Promise<void> | void;
        shouldShowPendingState?: boolean;
        resource: string;
        url?: never;
      }>
    | AllOrNone<{url: string | Nullish; resource: string; onClick?: never}>
  );
